import $http from '@/utils/http'

export function doGet(url) {
	return $http.get(url);
}
export function doPost(url, data) {
	return $http.post(url, data);
}




// 红十字会开始
export function leftData() {
	return $http.get('/api/phone/data/leftData')
}
export function centerData() {
	return $http.get('/api/phone/data/centerData')
}
export function rightData() {
	return $http.get('/api/phone/data/rightData')
}


// 红十字会结束

// 学生成长评价开始市级
export function cityLeftData() {
	return $http.get('/api/phone/data/leftData')
}
export function cityCenterData() {
	return $http.get('/api/phone/data/centerData')
}
export function cityRightData() {
	return $http.get('/api/phone/data/rightData')
}
// 学生成长评价结束

// 学生成长评价看板开始


export function getSchoolInfo(id) {
	return $http.get('/api/phone/data/getSchoolInfo?schoolId='+id)
}
export function leftDataSchool(id) {
	return $http.get('/api/phone/data/leftDataSchool?schoolId='+id)
}
export function centerDataSchool(id) {
	return $http.get('/api/phone/data/centerDataSchool?schoolId='+id)
}
export function rightDataSchool(id) {
	return $http.get('/api/phone/data/rightDataSchool?schoolId='+id)
}
// 学生成长评价看板结束